/** Display name for portal PDF comments and markup strokes. */
export function resolvePortalMarkupAuthorName(args: {
  isStaffPortalUser: boolean;
  userName?: string | null;
  userEmail?: string | null;
  clientDisplayName?: string | null;
}): string {
  if (args.isStaffPortalUser) {
    const staff = args.userName?.trim() || args.userEmail?.trim();
    return staff || 'Team Member';
  }
  const client = args.clientDisplayName?.trim();
  return client || 'Client';
}
